import React, { memo, useEffect, useMemo } from "react";
import { Text, View, useWindowDimensions, ScrollView } from "react-native";
import CustomPressable from "../../../components/customPressable/customPressable";
import { ImageComp } from "../../../components/Image/Image";
import { CHEVRON_RIGHT, MINUS, PLUS } from "../../../assets";
import { useCssStyle } from "../../../customHook/getCssStyle";
import { getCleanUrl } from "../../../utils/Helper";
import { useSelector } from "react-redux";
import RenderHTML from "react-native-render-html";

export const StoreLevel2_Landscape = memo((props) => {

    const getStyles = useCssStyle();
    const { width } = useWindowDimensions();

    const { onItemPress, onAddPress, selectedStoreItemSubType, handleStoreItemSubTypeSelect, menuIsAvailable = true, cartItem, handleRemoveFromCart } = props || {};

    const { currentWidget } = useSelector(state => state.deviceConfigSlice);

    const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
    const currencyCode = currencyDetails.code;

    const customWidgetHeaderTitleStyle = useMemo(() => {
        const style = getStyles(['widgetmainContainerHeaderTitle', 'hcommerce_storelevel2_landscape_HeaderTitle']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const customWidgetHeaderSubTitleStyle = useMemo(() => {
        const style = getStyles(['widgetmainContainerHeaderSubTitle', 'hcommerce_storelevel2_landscape_HeaderSubTitle']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const customWidgetTitleStyle = useMemo(() => {
        const style = getStyles(['list_itemContainer_textContainer_title', 'hcommerce_storelevel2_landscape_itemContainer_textContainer_title']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const customWidgetSubTitleStyle = useMemo(() => {
        const style = getStyles(['list_itemContainer_textContainer_subtitle', 'hcommerce_storelevel2_landscape_itemContainer_textContainer_subtitle']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);




    return (

        <View style={getStyles(['widgetmainContainer', 'hcommerce_storelevel2_landscape_MainContainer'])} id="widgetmainContainer hcommerce_storelevel2_landscape_MainContainer">

            {
                currentWidget?.widgetHeaderImageUrl &&
                <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'hcommerce_storelevel2_landscape_HeaderImg'])} id={`widgetmainContainerHeaderImg hcommerce_storelevel2_landscape_HeaderImg`} />
            }
            <ScrollView showsVerticalScrollIndicator={false}>
                <View style={getStyles(['widgetmainContainerHeaderContainer', 'hcommerce_storelevel2_landscape_HeaderContainer'])} id="widgetmainContainerHeaderContainer hcommerce_storelevel2_landscape_HeaderContainer">
                    <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'hcommerce_storelevel2_landscape_HeaderTitleContainer'])} id="widgetmainContainerHeaderTitleContainer hcommerce_storelevel2_landscape_HeaderTitleContainer">
                        <RenderHTML
                            contentWidth={width}
                            baseStyle={customWidgetHeaderTitleStyle}
                            source={{ html: selectedStoreItemSubType.subTypeName}}
                            systemFonts={[customWidgetHeaderTitleStyle.fontFamily]}
                            id={`widgetmainContainerHeaderTitle hcommerce_storelevel2_landscape_HeaderTitle`}
                        />
                        <RenderHTML
                            contentWidth={width}
                            baseStyle={customWidgetHeaderSubTitleStyle}
                            source={{ html: selectedStoreItemSubType.subTypeDescription || ''}}
                            systemFonts={[customWidgetHeaderSubTitleStyle.fontFamily]}
                            id={`widgetmainContainerHeaderSubTitle hcommerce_storelevel2_landscape_HeaderSubTitle`}
                        />
                    </View>
                </View>

                {!menuIsAvailable && (
                    <View style={getStyles(['hcommerce_menuUnavailableBanner'])}>
                        <Text style={getStyles(['hcommerce_menuUnavailableBannerText'])}>
                            This menu is currently not available for ordering. You can browse but cannot order items.
                        </Text>
                    </View>
                )}

                <View style={getStyles(['widgetmainContainerChildContainer', 'hcommerce_storelevel2_landscape_MainContainerChildContainer'])} id="widgetmainContainerChildContainer hcommerce_storelevel2_landscape_MainContainerChildContainer">

                    <View style={getStyles(['hcommerce_storelevel2_landscape_ChildContainer_items_container'])} id="hcommerce_storelevel2_landscape_ChildContainer_items_container">
                        {/* Render nested subcategories if they exist */}
                        {selectedStoreItemSubType?.subMenu && selectedStoreItemSubType.subMenu.length > 0 && (
                            selectedStoreItemSubType.subMenu.map((nestedSubCategory) => {
                                const imageUri = nestedSubCategory.storeItemTypeImages?.find(image => image.imageType === "LARGE")?.imagePath || nestedSubCategory.storeItemTypeImages?.[0]?.imagePath;

                                return (
                                    <CustomPressable key={nestedSubCategory.id} style={getStyles(['list_itemContainer', 'hcommerce_storelevel2_landscape_itemContainer'])} onPress={() => handleStoreItemSubTypeSelect(nestedSubCategory, menuIsAvailable)} id={`list_itemContainer hcommerce_storelevel2_landscape_itemContainer ${nestedSubCategory.id}`}>

                                        <View style={getStyles(['list_itemContainer_image', 'hcommerce_storelevel2_landscape_itemContainer_image'])} id="list_itemContainer_image hcommerce_storelevel2_landscape_itemContainer_image">
                                            {imageUri &&
                                                <ImageComp
                                                    source={getCleanUrl(imageUri)}
                                                    style={getStyles(["hcommerce_storelevel2_landscape_item_image"])}
                                                    id="hcommerce_storelevel2_landscape_item_image"
                                                />
                                            }
                                        </View>
                                        <View style={getStyles(['list_itemContainer_textContainer', 'hcommerce_storelevel2_landscape_itemContainer_textContainer'])} id="list_itemContainer_textContainer hcommerce_storelevel2_landscape_itemContainer_textContainer">
                                            <RenderHTML
                                                contentWidth={width}
                                                baseStyle={customWidgetTitleStyle}
                                                source={{ html: nestedSubCategory.subTypeName}}
                                                systemFonts={[customWidgetTitleStyle.fontFamily]}
                                                id={`list_itemContainer_textContainer_title hcommerce_storelevel2_landscape_itemContainer_textContainer_title_${nestedSubCategory.id}`}
                                                defaultTextProps={{
                                                    numberOfLines: 1
                                                }}
                                            />
                                            {nestedSubCategory.subTypeDescription &&
                                                <RenderHTML
                                                    contentWidth={width}
                                                    baseStyle={customWidgetSubTitleStyle}
                                                    source={{ html: nestedSubCategory.subTypeDescription}}
                                                    systemFonts={[customWidgetSubTitleStyle.fontFamily]}
                                                    id={`list_itemContainer_textContainer_subtitle hcommerce_storelevel2_landscape_itemContainer_textContainer_subtitle_${nestedSubCategory.id}`}
                                                    defaultTextProps={{
                                                        numberOfLines: 1
                                                    }}
                                                />
                                            }
                                        </View>

                                        <View style={getStyles(['list_itemContainer_arrow', 'hcommerce_storelevel2_landscape_itemContainer_arrow'])} id="list_itemContainer_arrow hcommerce_storelevel2_landscape_itemContainer_arrow">
                                            <ImageComp source={CHEVRON_RIGHT} style={getStyles(['list_itemContainer_arrow_img'])}/>
                                        </View>
                                    </CustomPressable>
                                )
                            })
                        )}



                        {/* Render items in the selected subcategory */}
                        {selectedStoreItemSubType?.storeItem && selectedStoreItemSubType.storeItem.length > 0 && 
                                selectedStoreItemSubType.storeItem.map((item) => {

                                    const totalQuantity = cartItem.reduce((total, cartItem) => {
                                        return cartItem.itemInfo.id == item.id ? total + cartItem.quantity : total;
                                    }, 0);

                                    // Determine if item has addons
                                    const hasItemAddOns = (item.addOnGroupReferences && item.addOnGroupReferences.length > 0) ||
                                                        (item.addOnItem && item.addOnItem.length > 0);

                                    const imageUri = item.storeItemImages?.find(image => image.imageType === "LARGE")?.imagePath || item.storeItemImages?.[0]?.imagePath;

                                    return (
                                        <CustomPressable key={item.id} style={getStyles(['list_itemContainer', 'hcommerce_storelevel2_landscape_itemContainer'])} onPress={() => onItemPress(item, hasItemAddOns)} id={`list_itemContainer hcommerce_storelevel2_landscape_itemContainer ${item.id}`}>

                                            <View style={getStyles(['list_itemContainer_image', 'hcommerce_storelevel2_landscape_itemContainer_image'])} id={`list_itemContainer_image hcommerce_storelevel2_landscape_itemContainer_image ${item.id}`}>
                                                {imageUri &&
                                                    <ImageComp
                                                        source={getCleanUrl(imageUri)}
                                                        style={getStyles(["hcommerce_storelevel2_landscape_item_image"])}
                                                        id="hcommerce_storelevel2_landscape_item_image"
                                                    />
                                                }
                                            </View>
                                            <View style={getStyles(['list_itemContainer_textContainer', 'hcommerce_storelevel2_landscape_itemContainer_textContainer'])} id={`list_itemContainer_textContainer hcommerce_storelevel2_landscape_itemContainer_textContainer ${item.id}`}>
                                                <RenderHTML
                                                    contentWidth={width}
                                                    baseStyle={customWidgetTitleStyle}
                                                    source={{ html: item.itemName}}
                                                    systemFonts={[customWidgetTitleStyle.fontFamily]}
                                                    id={`list_itemContainer_textContainer_title hcommerce_storelevel2_landscape_itemContainer_textContainer_title_${item.id}`}
                                                    defaultTextProps={{
                                                        numberOfLines: 1
                                                    }}
                                                />
                                                {item.itemDescription &&
                                                    <RenderHTML
                                                        contentWidth={width}
                                                        baseStyle={customWidgetSubTitleStyle}
                                                        source={{ html: item.itemDescription}}
                                                        systemFonts={[customWidgetSubTitleStyle.fontFamily]}
                                                        id={`list_itemContainer_textContainer_subtitle hcommerce_storelevel2_landscape_itemContainer_textContainer_subtitle_${item.id}`}
                                                        defaultTextProps={{
                                                            numberOfLines: 1
                                                        }}
                                                    />
                                                }


                                                <View style={getStyles(['list_itemContainer_textContainer_tertiaryContainer', 'hcommerce_storelevel2_landscape_itemContainer_textContainer_tertiaryContainer'])} id={`list_itemContainer_textContainer_tertiaryContainer hcommerce_storelevel2_landscape_itemContainer_textContainer_tertiaryContainer ${item.id}`} >

                                                    <Text style={getStyles(['list_itemContainer_textContainer_title', 'hcommerce_storelevel2_landscape_itemContainer_textContainer_title'])} id="list_itemContainer_textContainer_title hcommerce_storelevel2_landscape_itemContainer_textContainer_title" >{currencyCode + item.itemPrice}</Text>

                                                    <View style={getStyles(['additem_controls'])} id="additem_controls" >
                                                        {totalQuantity > 0 &&
                                                            <CustomPressable onPress={() => handleRemoveFromCart({...item, hasItemAddOns})} style={getStyles(['additem_controls_sub_container'])} id={`additem_controls_sub_container`}>
                                                                <ImageComp source={MINUS} style={getStyles(['additem_controls_sub_container_img'])} id="additem_controls_sub_container_img"/>
                                                            </CustomPressable>
                                                        }
                                                        {totalQuantity > 0 &&
                                                            <Text style={getStyles(['additem_controls_qty_text'])} id="additem_controls_qty_text">{totalQuantity}</Text>
                                                        }
                                                        <CustomPressable onPress={() => onAddPress(item, hasItemAddOns)} style={getStyles(['additem_controls_sub_container'])} id="additem_controls_sub_container">
                                                            <ImageComp source={PLUS} style={getStyles(['additem_controls_sub_container_img'])} id="additem_controls_sub_container_img"/>
                                                        </CustomPressable>

                                                    </View>

                                                </View>
                                            </View>
                                        </CustomPressable>
                                    )
                                }
                            )}
                    </View>

                </View>
            </ScrollView>
        </View>
    );
});

